var $94e7642cab24f6f7$exports = {};
$94e7642cab24f6f7$exports = {
    "info": `Informa\xe7\xf5es`,
    "negative": `Erro`,
    "notice": `Aviso`,
    "positive": `Sucesso`
};


export {$94e7642cab24f6f7$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
